import { getUser } from '../features/auth/requests';

export async function authLoader() {
  try {
    const user = await getUser();
    if (!user) {
      throw new Error('');
    }
    return { isAuthenticated: true, user };
  } catch (error) {
    return { isAuthenticated: false, user: null };
  }
}

export default authLoader;
